import { AutoComplete } from "./AutoComplete";
import { CheckBox } from "./Checkbox";
import { Image } from "./Image";
import { Input } from "./Input";
import { InputNumber } from "./InputNumber";
import { Select } from "./Select";
import { TextField } from "./TextField";
import { TextArea } from "./TextArea";
import { Carousel } from "./Carousel";
import { DateTimePicker } from "./DateTimePicker";
import { Radio } from "./Radio";
import { Password } from "./Password";
import { FileDropzone } from "./Dropzone";
import { Switch } from "./Switch";
import { SelectBuilder } from "./SelectBuilder/SelectBuilder";
import { File } from "./File";
import { CheckBoxGroup } from "./CheckBoxGroup";

export const Field = {
  AutoComplete,
  CheckBox,
  CheckBoxGroup,
  Image,
  Input,
  InputNumber,
  Select,
  TextField,
  TextArea,
  Carousel,
  DateTimePicker,
  Radio,
  Password,
  FileDropzone,
  Switch,
  SelectBuilder,
  File,
};
